var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '@web/utility';
import { useTranslation } from 'react-i18next';
export var CommunicationNetworkGraphShowExtendedInfoToggle = function (_a) {
    var checked = _a.checked, onToggle = _a.onToggle;
    var t = useTranslation().t;
    var label = checked
        ? t('app.dashboard.communicationChart.inspector.showLessInfo')
        : t('app.dashboard.communicationChart.inspector.showMoreInfo');
    return (_jsxs("button", __assign({ type: "button", onClick: onToggle, className: cx('mt-3 flex w-full items-center justify-between rounded-xl border px-3 py-1.5 text-left transition-all', checked
            ? 'border-indigo-300 bg-indigo-50/70 shadow-sm'
            : 'border-slate-300 bg-white hover:border-slate-400 hover:bg-slate-50') }, { children: [_jsx("span", __assign({ className: cx('text-[11px] font-semibold tracking-wide', checked ? 'text-indigo-600' : 'text-slate-700') }, { children: label })), _jsx("span", __assign({ className: cx('relative inline-flex h-4 w-8 shrink-0 items-center rounded-full border transition-colors', checked
                    ? 'border-indigo-400 bg-indigo-400'
                    : 'border-indigo-300 bg-indigo-100'), "aria-hidden": true }, { children: _jsx("span", { className: cx('inline-block h-3 w-3 rounded-full bg-white shadow transition-transform', checked ? 'translate-x-4' : 'translate-x-0.5') }) }))] })));
};
